import React from "react";
import { useTranslation } from "react-i18next";

import { useWallet } from "@services/metamask/WalletProvider.context";
import { useAppModals } from "@contexts/AppModals.context";
import { useAuth } from "@contexts/Auth.context";

import Button from "@components/dataEntry/buttons/Button/Button";
import Spinner from "@components/common/Spinner/Spinner";
import WalletAddress from "./WalletAddress/WalletAddress";

import "./ConnectMetamask.scss";

interface ConnectMetamaskProps {
  onClick?(): void;
}

const ConnectMetamask = ({ onClick }: ConnectMetamaskProps) => {
  const { metamaskStatus, walletAddress } = useWallet();
  const { authStatus } = useAuth();
  const { openModal } = useAppModals();

  const { t } = useTranslation("common");

  const connecting = metamaskStatus === "connecting" || authStatus === "logging";
  const connected = metamaskStatus === "connected" && authStatus !== "logging";

  const handleConnect = () => {
    onClick?.();
    if (metamaskStatus === "unavailable") {
      openModal({ type: "desktopDownloadMetamask" });
    } else {
      openModal({ type: "connectToMetamask" });
    }
  };

  return (
    <div className="connect-metamask">
      {!connected && (
        <>
          <Button onClick={handleConnect} className="connect-metamask-button desktop-flex-md">
            <img src="/images/metamask-signet.svg" alt="metamask signet" width={26} height={24} className="mr-2" />
            {connecting ? (
              <>
                {t("connecting")}
                <Spinner />
              </>
            ) : (
              <>{t("connectMetamask")}</>
            )}
          </Button>
          <Button onClick={onClick} className="connect-metamask-button mobile-flex-md">
            {connecting ? (
              <>
                {t("connecting")}
                <Spinner />
              </>
            ) : (
              <>
                <img src="/images/metamask-signet.svg" alt="metamask signet" width={26} height={24} className="mr-2" />
                {t("connect")}
              </>
            )}
          </Button>
        </>
      )}

      {connected && (
        <div className="connect-metamask-connected">
          <p className="p1 status-info"> {t("connected")}</p>

          <WalletAddress address={walletAddress || ""} />
        </div>
      )}
    </div>
  );
};

export default ConnectMetamask;
